import React from 'react';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import $ from "jquery";
var striptags = require('striptags');


class MatchQuestion extends React.Component{

    constructor(props) {
        super(props);
        /*this.selectAns = this.selectAns.bind(this);*/
    }


    selectAns(heading,desc,e){
      let selected = heading+'\n'+desc;
          let elements = this.resultMCAns.children;
          for(let i=0;i<elements.length;i++){
              if(e.target === elements[i]){
                  elements[i].setAttribute('checked',true)
                  elements[i].setAttribute('class','col-options2 selected')
              }else{
                  elements[i].removeAttribute('checked')
                  elements[i].setAttribute('class','col-options2')
              }
          }
          this.props.setResult(selected,e.target.value)

    }

    selectAdditionalAns(heading,desc,e){
        let selected = heading+'\n'+desc;
        let elements = this.resultMCAdditinalAns.children;
        for(let i=0;i<elements.length;i++){
            if(e.target === elements[i]){
                elements[i].setAttribute('checked',true)
                elements[i].setAttribute('class','col-options3 selected')
            }else{
                elements[i].removeAttribute('checked')
                elements[i].setAttribute('class','col-options3')
            }
        }
        this.props.setAdditionalResult(selected,e.target.value);
        $('html,body').animate({
                scrollTop: $(document).height()},
            'slow');
    }
    render(){

        //const renderHTML = (rawHTML) => React.createElement("label", { dangerouslySetInnerHTML: { __html: rawHTML } });
        let quizOptions;
        let quizOptionsAdditional;
        let options;
        options = this.props.frageOptions[1];
        /*options.push([1,this.props.frageOptions[0],this.props.frageOptions[1]])
        options.push([2,this.props.frageOptions[2],this.props.frageOptions[3]])
        options.push([3,this.props.frageOptions[4],this.props.frageOptions[5]])*/
        quizOptions = options.map((op,i)=>{
            let id=parseInt(op[0])
            let strippedOption = striptags(op[1]).toString();
            let strippedOptionDesc = striptags(op[2]).toString();

            return (

                <li
                    key={id}
                    value={id}
                    className="col-options2"
                    onClick={this.selectAns.bind(this,strippedOption,strippedOptionDesc)}
                    checked={false}
                    dangerouslySetInnerHTML={{__html:strippedOption}}
                >


                </li>


            );
        });

        quizOptionsAdditional = options.map((op,i)=>{
            let id=parseInt(op[0])
            let strippedOption = striptags(op[1]).toString();
            let strippedOptionDesc = striptags(op[2]).toString();
            return (

                <li
                    key={id}
                    value={id}
                    className="col-options3"
                    onClick={this.selectAdditionalAns.bind(this,strippedOption,strippedOptionDesc)}
                    checked={false}
                    dangerouslySetInnerHTML={{__html:strippedOption}}
                >

                </li>


            );
        });

        return(
            <div className="questionName centered">
                <div className="questionHeading">
                    <div dangerouslySetInnerHTML={{__html: this.props.frageTitle[0]}}></div>
                    <div dangerouslySetInnerHTML={{__html: this.props.frageTitle[1]}}></div>
                </div>
                <div className="matchQuestionMidHeading">
                    <div dangerouslySetInnerHTML={{__html: this.props.frageOptions[0][0]}}></div>
                    <div dangerouslySetInnerHTML={{__html: this.props.frageOptions[0][1]}}></div>
                    <div dangerouslySetInnerHTML={{__html: this.props.frageOptions[0][2]}}></div>
                    <div dangerouslySetInnerHTML={{__html: this.props.frageOptions[0][3]}}></div>
                    <div dangerouslySetInnerHTML={{__html: this.props.frageOptions[0][4]}}></div>
                    <div dangerouslySetInnerHTML={{__html: this.props.frageOptions[0][5]}}></div>
                </div>
                <div className="matchQuestionSecondHeading">
                    <div dangerouslySetInnerHTML={{__html: this.props.frageTitle[2]}}></div>

                    <div className="answerHeading">
                        <ul ref={input => {
                            this.resultMCAns = input;
                        }} >{quizOptions}</ul>

                    </div>
                </div>


                <div className="matchQuestionSecondHeading additional">
                    <div dangerouslySetInnerHTML={{__html: this.props.additionalFrageTitle}}></div>

                    <div className="answerHeading">
                        <ul ref={input => {
                            this.resultMCAdditinalAns = input;
                        }}>{quizOptionsAdditional}</ul>

                    </div>
                </div>

            </div>
        );
    }
}
export default MatchQuestion;
